export default "__VITE_ASSET__CZNoaaIv__"